import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './DealerCategories.module.css';

const CATEGORIES = [
  { labelKey: 'casino.liveCasino',  img: '/assets/images/dealer-tabs/evolution.webp',     route: '/casino/live-casino' },
  // { labelKey: 'home.indianGames',   img: '/assets/images/dealer-tabs/indian_games.webp',  route: '/casino/indian-games' },
  { labelKey: 'home.teenPatti',     img: '/assets/images/dealer-tabs/teen_patti.webp',    route: '/casino/teen-patti' },
  { labelKey: 'home.roulette',      img: '/assets/images/dealer-tabs/roulette.webp',      route: '/casino/roulette' },
  { labelKey: 'home.baccarat',      img: '/assets/images/dealer-tabs/baccarat.webp',      route: '/casino/baccarat' },
  // { labelKey: 'home.instantGames', img: '/assets/images/dealer-tabs/instant_games.webp', route: '/casino/instant-games' },
  { labelKey: 'home.dragonTiger',   img: '/assets/images/dealer-tabs/dragon_tiger.webp',  route: '/casino/dragon-tiger' },
  { labelKey: 'home.blackjack',     img: '/assets/images/dealer-tabs/blackjack.webp',     route: '/casino/blackjack' },
  { labelKey: 'home.poker',         img: '/assets/images/dealer-tabs/poker.webp',         route: '/casino/poker' },
  { labelKey: 'casino.slots',       img: '/assets/images/dealer-tabs/slots.webp',         route: '/casino/popular-slots' },
];

const DealerCategories = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const trackRef = useRef(null);

  const scroll = (dir) => {
    const el = trackRef.current;
    if (!el) return;
    el.scrollBy({ left: dir === 'right' ? 240 : -240, behavior: 'smooth' });
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.track} ref={trackRef}>
        {CATEGORIES.map(({ labelKey, img, route }) => (
          <div
            key={labelKey}
            className={styles.card}
            onClick={() => navigate(route)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && navigate(route)}
          >
            <div className={styles.contentBox}>
              <div className={styles.imageWrapper}>
                <img src={img} alt={t(labelKey)} className={styles.icon} loading="lazy" />
              </div>
              <div className={styles.title}>{t(labelKey)}</div>
            </div>
            <div className={styles.shimmer} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default DealerCategories;
